import React, { useEffect, useRef, useState } from 'react';
import { Tooltip, Typography } from '@mui/material';

function EllipsisText({ children, tooltipProps = {}, ...typographyProps }) {
  const ref = useRef(null);
  const [isEllipsed, setIsEllipsed] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const checkEllipsis = () => {
      if (!el) return;
      setIsEllipsed(el.scrollWidth > el.clientWidth);
    };

    checkEllipsis();

    // Optional: Handle window resize
    window.addEventListener('resize', checkEllipsis);
    return () => {
      window.removeEventListener('resize', checkEllipsis);
    };
  }, [children]);

  const text = (
    <Typography
      {...typographyProps}
      ref={ref}
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'block',
      }}
    >
      {children}
    </Typography>
  );

  return isEllipsed ? (
    <Tooltip title={children} {...tooltipProps} arrow>
      {text}
    </Tooltip>
  ) : (
    text
  );
}

export default EllipsisText;
